module.exports = __webpack_public_path__ + "static/media/blockchain.f4293cba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blockchain.svg
// module id = 1750
// module chunks = 0